// Initialize Sentry FIRST - before any other imports
import { createRoot } from "react-dom/client"
import "react-toastify/dist/ReactToastify.css"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { captureRefCode } from "@/helpers/refCode"
// import { registerSW } from "virtual:pwa-register"
// import { initSentry } from "./utils/sentry"
import { App } from "./App.tsx"
import "./localization"
import "./styles/index.scss"

// initSentry()

captureRefCode()

// Register service worker for PWA
// registerSW({
//   onNeedRefresh() {
//     console.log("New content available, refreshing...")
//   },
//   onOfflineReady() {
//     console.log("App ready to work offline")
//   },
// })

createRoot(document.getElementById("root")!).render(<App />)
